import axios from 'axios';
import getCookie, { get2FA, getToken, getUrlParamValue } from './cookies';

axios.interceptors.request.use(function (config) {
  // const Token = getCookie('token');
  const Token = getToken(true);
  const twoFA = get2FA();
  let Authorization;
  if (Token) {
    Authorization = "Bearer " + Token;
  }
  config.headers = {
    'Content-Type': 'application/json',
    'request-info': '{"rit":"123","cver": "1.0v","ch": "web","info":{' +
      (twoFA ? '"2faToken":"' + twoFA + '"' : "")
      + '}},"reqts":"12345678","payload":[]}',
      ...(getCookie("url_params")?.indexOf("vendor") > -1 ? {'x-api-key': getUrlParamValue('apikey')} : {}),
    Authorization,
    ...config.headers
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
  return response.data;
}, function (error) {
  // console.log("INTERCEPTOR", error);
  return Promise.reject(error.response.data || error);
});


export default axios;